<script>
    import R, {LOADER} from "../lib/requests";
    import app from "../stores/app"
    import Notifier from "../stores/notifier";
    import {setFocusTo} from "../lib/lib";
    import Modal from "../components/modal/Modal.svelte";
    import ComponentLoader from "../components/ComponentLoader.svelte";
    import AppIcon from "../components/icons/AppIcon.svelte";
    import Checkbox from "../components/controls/Checkbox.svelte";

    export let printItems;
    export let closeCallback;

    let title = 'Εξαγωγή';
    let client = null;
    let order = null;
    let pdfFilename = null;
    let fileList = null;
    let loading = false;
    let exportError = false;

    const exportSamples = () => {

        const onSuccess = result => {
            client = result.client;
            order = result.order;
            pdfFilename = result.filename;
        };

        const onFailure = err => {
            exportError = true;
        };

        R.handle(R.order.exportSamples, {samples: printItems.samples, cloud: 1}, onSuccess, onFailure, LOADER.POPUP);
    };

    const deleteFiles = () => {
        const onSuccess = result => {
        };

        const onFailure = err => {
        };

        R.handle(R.order.deleteFile, {filename: pdfFilename}, onSuccess, onFailure, LOADER.NONE);
    }

    const close = (param) => {
        deleteFiles();

        if (param instanceof Event) {
            closeCallback();
            return;
        }

        setTimeout(() => {
            closeCallback(param);
        }, 200);
    }


    if (printItems.samples.length == 1) {
        title = "Εκτύπωση δείγματος";
    } else {
        title = "Εκτύπωση δειγμάτων";
    }
    exportSamples();
</script>

<Modal title="{ title }" modalXl="{ printItems.object === 'samples' }" on:close="{ close }">
    <div slot="body">
        {#if loading}
            <div class="py-4">
                <ComponentLoader size="50" loading/>
                <p class="text-center mt-3">Δημιουργία Pdf αρχείων</p>
            </div>
        {/if}
        {#if exportError}
            <div class="py-4">
                <div class="text-gray-1">
                    <AppIcon icon="exclamation-triangle-solid" size="50"/>
                </div>
                <p class="text-center mt-3">Παρουσιάστηκε κάποιο σφάλμα κατά την δημιουργία των αρχείων!</p>
            </div>
        {/if}
        {#if pdfFilename}
            <object data="{ $app.app_url }/cloud/{ pdfFilename }?ver={ Math.random() }" type="application/pdf"
                    class="pdf-container"></object>
        {/if}
    </div>
</Modal>

<style>
    .pdf-container {
        width: 100%;
        height: 1200px;
    }

    @media (max-width: 576px) {
        .pdf-container {
            height: calc(100vh - 255px);
        }
    }

    @media (min-width: 577px) and (max-width: 767px) {
        .pdf-container {
            height: calc(100vh - 255px);
        }
    }

    @media (min-width: 768px) and (max-width: 991px) {
        .pdf-container {
            height: calc(100vh - 205px);
        }
    }

    @media (min-width: 992px) and (max-width: 1199px) {
        .pdf-container {
            height: calc(100vh - 105px);
        }
    }

    @media (min-width: 1200px) {
        .pdf-container {
            height: calc(100vh - 105px);
        }
    }
</style>